import styled from "styled-components";
import Text from "shared/components/data-display/mui/Text";
import { mediaQueries } from "shared/config/breakpoints";

export const TextWrapper = styled.div`
    padding: 0.5rem;

    ${mediaQueries.small} {
        padding: 0.25rem;
    }
`;

export const LoaderWrapper = styled.div`
    padding: 1rem;
    text-align: center;

    ${mediaQueries.small} {
        padding: 0.5rem;
    }
`;

export const Wrapper = styled.div`
    display: grid;
    justify-content: center;

    ${mediaQueries.small} {
        width: 100%;
        padding: 0 1rem;
        box-sizing: border-box;
    }
`;

export const ResponsiveText = styled(Text)`
    ${mediaQueries.small} {
        font-size: 14px;
        text-align: center;
    }
`;
